import React, { useEffect, useState } from 'react';
import { globals } from '../../misc/globals';
import { BaseConfig } from '../BaseConfig';
import { UIProperties } from '../UIProperties';

import './ContinueButton.css'

const ContnueButton = (props: UIProperties<ContnueButtonConfig>) => {
	const [isOver, setIsOver] = useState(false);
	useEffect(() => {

	}, [isOver])

	return (
		<div style={{
			position: 'absolute',
			top: props.parameters.top,
			left: props.parameters.left,
			width: props.parameters.width
		}}>
			<button id={props.parameters.id} tabIndex={0} aria-label={'continue'} className="pointer" style={{
				position: 'relative',
				background: 'transparent',
				pointerEvents: props.parameters.isDisabled ? 'none' : 'all'
			}} 
			onMouseEnter={() => {
				var rollOverAudio = document.getElementById('button-rollover');
				
				if(!globals.isMuted) {
					(rollOverAudio as any).play();
				}
			}}
			aria-disabled={props.parameters.isDisabled}
			onMouseDown={() => {
				setIsOver(true);
			}} onMouseUp={() => {
				setIsOver(false);
			}} onMouseOut={() => {
				setIsOver(false);
			}} onClick={() => {
				if(props.parameters.isDisabled) {
					return;
				}
				var clickAudio = document.getElementById('button-click');
				
				if(!globals.isMuted) {
					(clickAudio as any).play();
				}
				if(props.parameters.onClicked) {
					props.parameters.onClicked();
				}
			}}>
				{<img style={{
					pointerEvents: 'none'
				}} src="./assets/images/general/buttons/button_continue_main.png" />}
				{isOver ? (<img style={{
					position: 'absolute',
					top: '0',
					left: '0',
					width: '100%',
					height: '100%',
					pointerEvents: 'none'
				}} src="./assets/images/general/buttons/button_continue_down.png" />) : (<div></div>)}
				{props.parameters.isDisabled ? (<img style={{
					position: 'absolute',
					top: '0',
					left: '0',
					width: '100%',
					height: '100%',
					pointerEvents: 'none'
				}} src="./assets/images/general/buttons/button_continue_disabled.png" />) : (<div></div>)}
			</button>
		</div>
	);

};

export interface ContnueButtonConfig extends BaseConfig{
	top: string;
	left: string;
	id?: string;
	width: string;
	isDisabled?: boolean;
	onClicked: () => void;
}

export default ContnueButton;